import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from "../../assets/images/logo.png";
import {
  LayoutDashboard,
  FileText,
  PenSquare,
  Globe,
  LogOut,
  Menu,
  X,
  MessageSquare,
  UserCircle,
} from 'lucide-react';


const navItems = [
  { key: 'dashboard',  labelNe: 'ड्यासबोर्ड',       labelEn: 'Dashboard',        icon: LayoutDashboard, path: '/editor/dashboard' },
  { key: 'articles',   labelNe: 'सबै लेखहरू',        labelEn: 'All Articles',     icon: FileText,        path: '/editor/articles' },
  { key: 'create',     labelNe: 'नयाँ लेख',          labelEn: 'Create Article',   icon: PenSquare,       path: '/editor/create-article' },
  { key: 'profile',    labelNe: 'प्रोफाइल सेटिङ',    labelEn: 'Profile Settings', icon: UserCircle,      path: '/editor/profile' },
  { key: 'feedback',    labelNe: "प्रतिक्रिया दिनुहोस् ", labelEn: "feedback", icon: MessageSquare , path: '/editor/feedback', external: false}
];

const EditorSidebar = ({ language }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isNe = language === 'ne';
  const label = (item) => (isNe ? item.labelNe : item.labelEn);

  const isActive = (item) => location.pathname === item.path;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = (name) =>
    (name || 'E').split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join('');

  const SidebarContent = () => (
    <div className="flex h-full flex-col">
      {/* Logo */}
      <div className="flex items-center px-10 py-5">
        <img src={logo} alt="भोलिको इटहरी" className="w-[1500px] h-[150px] object-contain" />
      </div>

      {/* Nav */}
      <nav className="mt-4 flex-1 space-y-0.5 px-3">
        {navItems.map((item) => {
          const active = isActive(item);
          return (
            <NavLink
              key={item.key}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              className={`flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-bold transition-all duration-150 ${
                active ? 'bg-primary-100 text-primary shadow-sm' : 'text-char-600 hover:bg-char-50 hover:text-char-900'
              }`}
            >
              <item.icon size={17} className={active ? 'text-primary' : 'text-char-400'} />
              <span>{label(item)}</span>
            </NavLink>
          );
        })}
      </nav>

      {/* Bottom actions */}
      <div className="mt-auto space-y-1 border-t border-char-100 px-3 pb-4 pt-4">
        <button
          onClick={() => navigate('/')}
          className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-bold text-char-600 transition-all hover:bg-char-50 hover:text-char-900"
        >
          <Globe size={17} className="text-char-400" />
          <span>{isNe ? 'साइटमा फर्कनुहोस्' : 'Back to Site'}</span>
        </button>
        <button
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-bold text-char-600 transition-all hover:bg-error-50 hover:text-error"
        >
          <LogOut size={17} className="text-char-400" />
          <span>{isNe ? 'लगआउट' : 'Logout'}</span>
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop sidebar */}
      <aside className="sticky top-0 hidden h-screen w-56 flex-shrink-0 flex-col overflow-y-auto bg-white border-r border-char-100 lg:flex">
        <SidebarContent />
      </aside>

      {/* Mobile hamburger */}
      <button
        className="fixed left-4 top-4 z-50 flex h-9 w-9 items-center justify-center rounded-xl text-char-700 bg-white shadow-lg lg:hidden"
        onClick={() => setMobileOpen(true)}
        aria-label="Open menu"
      >
        <Menu size={20} />
      </button>

      {/* Mobile drawer */}
      {mobileOpen && (
        <>
          <div className="fixed inset-0 z-40 bg-black/40 lg:hidden" onClick={() => setMobileOpen(false)} />
          <aside className="fixed inset-y-0 left-0 z-50 flex w-56 flex-col overflow-y-auto bg-white border-r border-char-100 lg:hidden">
            <button
              className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-lg text-char-400 hover:bg-char-50 hover:text-char-900"
              onClick={() => setMobileOpen(false)}
            >
              <X size={18} />
            </button>
            <SidebarContent />
          </aside>
        </>
      )}
    </>
  );
};

export default EditorSidebar;